import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  UploadFile,
  UploadProps,
  message,
} from "antd";
import Modal from "antd/lib/modal/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getFilesCategories,
  pollStatusFileAdmin,
  validateFile,
} from "../../../core/store/reducers/files.slice";
import Upload, { RcFile } from "antd/lib/upload";
import {
  uploadFilePath,
  uploadFilePathAdmin,
} from "../../../core/store/reducers/upload.slice";
import axios from "axios";
import { convertFileSizeFromBytes } from "../../../shared/utilities";
import PopupMessageComponent from "../../../shared/layouts/message.layout";
import { readAsArrayBufferAsync } from "../../FileConfiguration/components/admin-document-upload.components";
import {
  getAnnouncementCategories,
  getAudienceList,
  getAudienceListMinimal,
  putAnnouncementCreateEdit,
  putAudienceCreateCsv,
  uploadFilePathAnnouncement,
  uploadFilePathAudience,
} from "../../../core/store/reducers/annoucements.slice";
import { useHistory, useParams } from "react-router-dom";
import {
  ROUTE_ANNOUNCEMENTS,
  ROUTE_ANNOUNCEMENTS_CONFIG,
} from "../../../core/route/ui.routes";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
function CreateEditAnnouncement({
  formVisible,
  setFormVisible,
  selectedAnnouncement,
  onClose,
  reloadList = () => {},
}: any) {
  const dispatch = useDispatch();
  const params: any = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileListData, setFileListData] = useState([] as any);
  const [errorFileListData, setErrorFileListData] = useState([] as any);
  const [uploading, setUploading] = useState(false);
  const [audienceList, setAudienceList] = useState(null as any);
  const [announcementCategories, setAnnouncementCategories] = useState(
    [] as any
  );
  const [modalVisible, setModalVisible] = useState(false as any);
  const [modalType, setModalType] = useState("" as any);
  const [modalButtons, setModalButtons] = useState((<></>) as any);
  const [modalTitle, setModalTitle] = useState("" as any);
  const [modalSubTitle, setModalSubTitle] = useState("" as any);
  const [formValues, setFormValues] = useState(
    selectedAnnouncement
      ? {
          ...selectedAnnouncement,
          start_date: moment(selectedAnnouncement.start_date),
          end_date: moment(selectedAnnouncement.end_date),
        }
      : ({ announcement_type: "file" } as any)
  );
  useEffect(()=>{
    if(selectedAnnouncement?.announcement_type == 'file'){
      let ext = selectedAnnouncement?.announcement_ref.split(".");
      ext = ext[ext?.length - 1]
      setFileListData([{
        file : {name: selectedAnnouncement?.filename || selectedAnnouncement?.announcement_ref, size: selectedAnnouncement?.file_size}, blobname: selectedAnnouncement?.announcement_ref, url: selectedAnnouncement?.ref_url, ext
      }])
    }
  }, [selectedAnnouncement])
  useEffect(() => {
    dispatch(getAnnouncementCategories()).then((val: any) => {
      if (val?.payload?.data?.data) {
        setAnnouncementCategories(val?.payload?.data?.data);
      }
    });
    dispatch(getAudienceListMinimal()).then((val: any) => {
      if (val?.payload?.data?.data) {
        setAudienceList(val?.payload?.data?.data);
      }
    });
  }, []);
  const handleUpload = async (file: any, ext: string) => {
    try {
      const filename = file.name.split("." + ext).join("");
      const response = await dispatch(
        uploadFilePathAnnouncement({
          filename: filename,
          filetype: ext
        })
      );
      if (!response?.payload?.data?.data) {
        removeFile();
        message.error("Something went wrong.", 10);
      }
      const {
        data: {
          data: { blobname, url },
        },
      } = response.payload;
      try {
        const binaryFile = await readAsArrayBufferAsync(file as RcFile);
        setUploading(true);
        const payload: any = {
          headers: {
            "Content-Type": file.type || "",
            "x-ms-blob-type": "BlockBlob",
          },
          method: "PUT",
          data: binaryFile,
          url: url,
          timeout: 0,
        };
        const fileUploaded = await axios.request(payload);
        if (fileUploaded.status === 200 || fileUploaded.status === 201) {
          setUploading(false);
          setFileListData([
            { file, blobname: blobname, url, fileUploaded: 1, ext: ext },
          ]);
        }
      } catch (e) {
        removeFile();
        setUploading(false);
        message.error("Something went wrong.", 10);
      }
    } catch (e) {
      removeFile();
      setUploading(false);
      message.error("Something went wrong.", 10);
    }
  };
  const removeFile = () => {
    setFileList([]);
    setFileListData([]);
    setErrorFileListData([]);
  };
  const props: UploadProps = {
    showUploadList: false,
    onRemove: (file) => {
      removeFile();
    },
    beforeUpload: (file) => {
      const maxSizeInBytes = 5 * 1024 * 1024; // 2 MB in bytes
      if (file.size > maxSizeInBytes) {
        message.warning("File size must be up to 5 MB", 10);
        setErrorFileListData([{ file }]);
        return false;
      }
      if (fileListData.length >= 2) {
        message.warning("You can only upload max 1 files", 10);
        return false;
      }
      const { name } = file;
      let ext: any = name?.split(".");
      ext = ext?.length > 0 ? ext[ext.length - 1] : "";
      if (["pdf", "jpg"].includes(ext)) {
      } else {
        message.error("Uploaded file is not valid", 10);
        return;
      }

      setFileList([file]);
      setFileListData([{ file, ext }]);
      handleUpload(file, ext);
      return false;
    },
    maxCount: 1,
    fileList,
  };
  const onFormValuesChange = (value: any, allValues: any) => {
    if(value?.announcement_type){
      removeFile()
      delete allValues?.announcement_ref
      form.setFieldValue('announcement_ref', null)
    }
    setFormValues(allValues);
  };

  const closeModalPopup = () => {
    setModalVisible(false);
    setModalType("");
    setModalButtons(<></>);
    setModalSubTitle("");
    setFormVisible(false);
    onClose()
    setModalTitle("");
    // if (returnType == 1) history.push(ROUTE_ANNOUNCEMENTS_CONFIG);
    // else
    reloadList();
  };
  const openSuccessModal = () => {
    if(selectedAnnouncement?.announcement_id){
      setModalTitle("Announcement Saved");
    }else{
      setModalTitle("New Announcement Created");
    }
    
    setModalType("success");
    setModalSubTitle("");
    setModalButtons(<></>);
    setModalVisible(true);
  };

  const onSave = async () => {
    const payload = {
      ...(selectedAnnouncement?.announcement_id ? {announcement_id: selectedAnnouncement?.announcement_id} : {}),
      ...formValues,
      start_date: moment(formValues.start_date).format("YYYY-MM-DD"),
      end_date: moment(formValues.end_date).format("YYYY-MM-DD"),
      announcement_ref: formValues?.announcement_type == "video" ? formValues?.announcement_ref : fileListData[0]?.blobname,
      ...(formValues?.announcement_type == "file" ? {filename: fileListData[0].file.name} : {}),
      ...(formValues?.announcement_type == "file" ? {file_size: fileListData[0]?.file?.size} : {})
    };
    const res = await dispatch(putAnnouncementCreateEdit(payload));

    if (res?.payload?.status == 200) {
      openSuccessModal();
    } else {
      message.error("Some error occured while saving announcement", 10);
    }
  };

  return (
    <>
      <Modal
        open={formVisible}
        onCancel={() => {
          setFormVisible(false)
          onClose()
        }}
        footer={false}
        title={`${selectedAnnouncement ? "Edit" : "Create New"} Announcement`}
        className="modalFormButton form-modal"
        style={{ paddingBottom: "0px" }}
        centered={true}
      >
        <Form
          className="app-form p-4"
          form={form}
          name={"csv_form"}
          onValuesChange={onFormValuesChange}
          // initialValues={selectedAnnouncement ? {
          //   ...selectedAnnouncement
          // }: {
          //   announcement_type: 'file'
          // }}
          initialValues={formValues}
          onFinish={onSave}
        >
          <Row gutter={20} align="bottom">
            <Col span={24}>
              <Form.Item
                label="Enter Announcement Name"
                name="announcement_name"
                rules={[
                  { required: true, message: "Announcement Name is required" },
                ]}
              >
                <Input showCount={true} maxLength={200} placeholder="Enter Announcement Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Announcement Category"
                name="announcement_category"
                rules={[
                  {
                    required: true,
                    message: "Announcement Category is required",
                  },
                ]}
              >
                <Select placeholder="Select Announcement Category ">
                  {announcementCategories?.map((val: any) => (
                    <Select.Option value={val}>{val}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Choose Audience"
                name="audience_id"
                rules={[{ required: true, message: "Audience is required" }]}
              >
                <Select
                  placeholder="Choose Audience"
                  showSearch={true}
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {audienceList?.map((val: any) => (
                    <Select.Option value={val?.audience_id}>
                      {val?.audience_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Start Date"
                name="start_date"
                rules={[{ required: true, message: "Start Date is required" }]}
              >
                <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} disabledDate={(d:any) => d < moment().subtract(1, 'd')} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="End Date"
                name="end_date"
                rules={[{ required: true, message: "End Date is required" }]}
              >
                <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} disabledDate={(d:any) => d < (formValues?.start_date || moment().subtract(1, 'd'))} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Upload"
                name="announcement_type"
                rules={[{ required: true, message: "Upload Type is required" }]}
              >
                <Radio.Group optionType="default">
                  <Radio.Button value={"file"}>File</Radio.Button>
                  <Radio.Button value={"video"}>Video Link</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            {formValues?.announcement_type == "video" ? (
              <Col span={24}>
                <Form.Item
                  name="announcement_ref"
                  rules={[{ required: true, message: "Video URL is required" },
                  () => ({
                    validator(_: any, value: any) {
                      if (
                        !value || value == '' || (!value?.includes('sharepoint') && !value?.includes('iframe')) 
                      ) {
                        return Promise.reject(
                          new Error(
                            "Please input valid Video Embed URL or Embed Code"
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                >
                  <Input placeholder="Enter Video URL" />
                </Form.Item>
              </Col>
            ) : (
              // {/* <Col span={9}>
              //   <a href={selectedTemplateUrl}><Button className="mb-3" block type="primary" disabled={!categoryId}>Download Template</Button></a>
              // </Col> */}
              <Col span={24}>
                {fileListData?.length == 0 &&
                  errorFileListData?.length == 0 && (
                    <div className="admin-upload-component p-4">
                      <img
                        src={
                          require("../../../assets/icons/cloud-upload.svg")
                            .default
                        }
                        width="140"
                      />
                      <p className="title m-0">Upload PDF/JPG File</p>
                      <p className="sub-text m-0">
                        (Max file size allowed 5Mb)
                      </p>
                      <Upload {...props}>
                        <Button
                          // disabled={!audienceName || audienceName == ""}
                          loading={uploading}
                          type="primary"
                          className="mt-4"
                        >
                          Select File
                        </Button>
                      </Upload>
                    </div>
                  )}
                {(fileListData?.length == 1 ||
                  errorFileListData?.length == 1) && (
                  <>
                    {/* <div className="ant-form-item-label">
                    <label>PDF/JPG File</label>
                  </div> */}
                    <div
                      className={`admin-file-component ${
                        errorFileListData?.length == 1 ? "danger" : ""
                      }`}
                    >
                      <Row align="middle" gutter={12} className="pb-2">
                        <Col flex="none">
                          {fileListData[0]?.ext == 'pdf' ? <img
                            src={
                              require("../../../assets/icons/pdficon.svg")
                                .default
                            }
                            height={50}
                          />
                          :<img
                            src={
                              require("../../../assets/icons/image-icon.svg")
                                .default
                            }
                            height={50}
                          />}
                        </Col>
                        <Col flex="auto" style={{maxWidth: 'calc(100% - 120px)'}}>
                          <p className="title m-0">
                            {fileListData[0]?.file?.name ||
                              errorFileListData[0]?.file?.name}
                          </p>
                          <p className="sub-text m-0">
                            {convertFileSizeFromBytes(
                              fileListData[0]?.file?.size ||
                                errorFileListData[0]?.file?.size
                            )}{" "}
                            {fileListData?.length == 1 && `• File Uploaded`}
                          </p>
                        </Col>
                        <Col flex="none">
                          <Row>
                            <Col>
                              <Button
                                type="link"
                                onClick={removeFile}
                                icon={
                                  <img
                                    src={
                                      require("../../../assets/icons/close.svg")
                                        .default
                                    }
                                  />
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {fileListData?.length == 1 &&
                                !fileListData[0].blobname && (
                                  <span className={`percent success`}>0%</span>
                                )}
                              {fileListData?.length == 1 &&
                                fileListData[0].blobname && (
                                  <span className={`percent success`}>
                                    100%
                                  </span>
                                )}
                              {errorFileListData?.length == 1 && (
                                <span className={`percent danger`}>Failed</span>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <div
                            className={`progress-bar ${
                              fileListData?.length == 1 &&
                              fileListData[0].blobname
                                ? "success"
                                : ""
                            } ${
                              errorFileListData?.length == 1 ? "danger" : ""
                            }`}
                          ></div>
                        </Col>
                      </Row>
                    </div>
                    {errorFileListData?.length == 1 && (
                      <Row>
                        <Col className={`admin-error-message pt-2`} span={24}>
                          Error: File size is too large to be uploaded. Files
                          larger than <br />
                          5mb size are not supported.
                        </Col>
                      </Row>
                    )}
                  </>
                )}
              </Col>
            )}
            <Col span={24}>
              <Form.Item label="Enter Description" name="description" rules={[{ required: true, message: "Description is required" }]}>
                <TextArea showCount={true} maxLength={500} placeholder="Enter Description" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col span={20}>
                  <Button
                    type="primary"
                    className="mt-4"
                    size="large"
                    htmlType="submit"
                    disabled={
                      !(
                        fileListData?.length > 0 &&
                        fileListData[0]?.blobname
                      ) && !formValues?.announcement_ref
                    }
                    block
                  >
                    {`${selectedAnnouncement ? "Save" : "Create"} Announcement`}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>
      {modalVisible && (
        <PopupMessageComponent
          open={modalVisible}
          onCancel={closeModalPopup}
          title={modalTitle}
          subTitle={modalSubTitle}
          type={modalType}
          buttons={modalButtons}
        />
      )}
    </>
  );
}
export default CreateEditAnnouncement;
